<template>
	<div class="timeline">
		<img src="../assets/about/bg_timeline-left.png" class="bg_timeline-left" />
		<img
			src="../assets/about/bg_timeline-right.png"
			class="bg_timeline-right"
		/>
		<div class="container">
			<div class="year">
				<div class="up">
					<template v-for="(value, key) in timelineData">
						<div
							class="y-item"
							@click="changeYear(key)"
							:class="{ active: currentYear == key }"
							:key="key"
						>
							<div class="text">{{ key }}</div>
							<div class="spot"></div>
						</div>
					</template>
				</div>
				<hr class="line" />
			</div>
			<div class="down">
				<template v-for="(value, key) in timelineData">
					<template v-for="(data, i) in value">
						<div
							class="year-content"
							:key="`${key}-${i}`"
							v-show="currentYear == key"
						>
							<div class="c-item">
								<div class="spot"></div>
								<div class="date">{{ data.time }}</div>
								<div class="content">
									<pre>{{ data.content1.trim() }}</pre>
									<template v-for="(src, j) in data.pic1">
										<img class="pic" :src="src" :key="`${i}-${j}`" />
									</template>
									<br />
									<pre>{{ data.content2 }}</pre>
								</div>
							</div>
						</div>
					</template>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import timelineData from "../../static/assets/program/timelineData.json";
export default {
	data() {
		return {
			currentYear: Object.keys(timelineData).sort((a, b) => b - a)[0],
			timelineData,
		};
	},
	methods: {
		changeYear(year) {
			this.currentYear = year;
		},
	},
};
</script>
<style scoped lang="scss">
.timeline {
	position: relative;
}
.bg_timeline-left {
	display: none;
	position: absolute;
	width: 20%;
	bottom: 0;
	left: 0;
	z-index: -1;
	@media (min-width: 790px) {
		display: block;
	}
}
.bg_timeline-right {
	display: none;
	position: absolute;
	width: 20%;
	top: -60px;
	right: 0;
	z-index: -1;
	@media (min-width: 790px) {
		display: block;
	}
}
.timeline .container .year .up {
	flex-wrap: wrap;
}
.up {
	.spot {
		display: none;
		@media (min-width: 790px) {
			display: block;
		}
	}
	@media (max-width: 789px) {
		.y-item {
			background-color: #000;
			color: #fff;
			padding: 3px 5px;
			margin: 5px 0;
			border-radius: 20px;
		}
		.y-item.active {
			background-color: #0fbae3;
			.text {
				color: #fff !important;
			}
		}
	}
}
.line {
	display: none;
	@media (min-width: 790px) {
		display: block;
	}
}
@media (max-width: 789px) {
	.container {
		padding: 0% 20px !important;
	}
}
</style>

<style scoped lang="sass">
@import '../stylesheet/base.sass'
@import '../stylesheet/layout.sass'
.timeline
  width: 100%
  .container
    max-width: 1000px
    padding: 5% 50px
    width: 100%
    .year
      +flexLayout('center', 'col')
      position: relative
      .up
        +flexLayout('between', 'row')
        z-index: 10
        width: 100%
        .y-item
          +flexLayout('center', 'col')
          position: relative
          cursor: pointer
          .text
            font-size: 18px
            font-weight: 500
          .spot
            +size(10px, 10px)
            border-radius: 50%
            background-color: #6d9ee1
            margin-top: 5px
          &:hover
            .text
              color: #0fbae3
              font-size: 20px
            .spot
              background-color: #0fbae3
        .active
          .text
            color: #0fbae3
            font-size: 20px
          .spot
            background-color: #0fbae3
      .line
        border: solid 1px #002c51
        width: 95%
        position: relative
        top: -22px
    .down
      .year-content
        .c-item
          +flexLayout('start', 'row')
          width: 80%
          margin: auto
          font-size: 16px
          padding: 20px 0
          line-height: 1.3
          letter-spacing: 2px
          align-items: flex-start
          .spot
            +size(10px, 10px)
            background-color: #e1e16d
            border-radius: 50%
            margin-right: 50px
          .date
            color: #9b9b3b
            font-size: 14px
            font-weight: 500
            width: 80px
            text-align: right
            margin-right: 20px
          .content
            flex: 1
            pre
              white-space: pre-line
              overflow: hidden
          .pic
            margin-top: 10px
            width: 100%
          @media all and (max-width: 790px)
            +flexLayout('center', 'col')
            .spot
              display: none
              margin-right: 0px
            .date
              width: initial
</style>



// WEBPACK FOOTER //
// src/components/timeline.vue